import { render, staticRenderFns } from "./PosCropImageUpload.vue?vue&type=template&id=15aed48e&scoped=true&"
import script from "./PosCropImageUpload.vue?vue&type=script&lang=js&"
export * from "./PosCropImageUpload.vue?vue&type=script&lang=js&"
import style0 from "./PosCropImageUpload.vue?vue&type=style&index=0&id=15aed48e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aed48e",
  null
  
)

export default component.exports